import { MapPin, CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";

const CITIES = [
  "Arlington",
  "Mansfield",
  "Grand Prairie",
  "Kennedale",
  "Fort Worth",
  "Pantego",
  "Dalworthington Gardens",
  "Euless",
  "Bedford",
  "Hurst",
  "Grapevine",
  "Burleson",
];

export function CoverageMap() {
  return (
    <section className="mx-auto max-w-7xl px-6 py-24">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-accent">
          Service Area
        </p>
        <h2 className="mt-3 font-display text-4xl text-primary md:text-5xl">
          Proudly serving Arlington & the DFW Metroplex.
        </h2>
        <p className="mt-5 text-muted-foreground">
          Based in Arlington, TX — we cover homes within roughly 15 miles of the city.
          Not sure if you're in range? Call Bart and ask.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-8 lg:grid-cols-5">
        <Reveal className="lg:col-span-3">
          <div className="relative h-[380px] overflow-hidden rounded-2xl border border-border bg-primary/5 shadow-xl md:h-[450px]">
            <iframe
              title="Map of The Crew Paint Contractors service area in Arlington, TX"
              src="https://www.google.com/maps?q=Arlington,TX&z=10&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="absolute inset-0 h-full w-full border-0"
            />
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-2">
          <div className="h-full rounded-2xl border border-border bg-card p-8">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent/10 text-accent">
                <MapPin className="h-5 w-5" />
              </div>
              <h3 className="font-display text-xl text-primary">Cities we cover</h3>
            </div>
            <ul className="mt-6 grid grid-cols-2 gap-y-3 gap-x-4 text-sm">
              {CITIES.map((c) => (
                <li key={c} className="flex items-center gap-2 text-foreground/85">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-accent" /> {c}
                </li>
              ))}
            </ul>
            <p className="mt-8 text-sm text-muted-foreground">
              Outside this list? Call us anyway — we travel for the right project.
            </p>
            <a
              href="tel:6824545997"
              className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary px-6 py-3.5 text-sm font-semibold text-primary-foreground hover:opacity-90"
            >
              Call 682-454-5997
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
